'use client';

import { Section } from '@workspace/interfaces';
import { cn } from '@/app/lib/utils';
import { Button } from '@workspace/ui/common/Buttons/Button';

interface DocumentHubLoadMoreControlsProps {
  section: Section;
  showControls: boolean;
  onLoadMore: (section: Section) => void;
  onShowAll: (section: Section) => void;
}

export function DocumentHubLoadMoreControls({
  section,
  showControls,
  onLoadMore,
  onShowAll,
}: DocumentHubLoadMoreControlsProps) {
  if (!showControls) return null;

  return (
    <div className="mt-16 flex justify-center gap-8">
      <Button
        variant="tertiary"
        onClick={() => onLoadMore(section)}
        className={cn('underline !p-0 !text-sm !font-bold !text-primary !bg-transparent justify-end')}
      >
        Load More
      </Button>
      <Button
        variant="tertiary"
        onClick={() => onShowAll(section)}
        className={cn('underline !p-0 !text-sm !font-bold !text-primary !bg-transparent justify-start')}
      >
        Show All
      </Button>
    </div>
  );
}
